import { Component, OnInit, Input } from '@angular/core';
import { StorageService } from 'app/storageprovider';
import { Utility } from '../../../_service/utility';

@Component({
  selector: 'app-box-arrow',
  templateUrl: './box-arrow.component.html',
  styleUrls: ['./box-arrow.component.scss']
})
export class BoxArrowComponent implements OnInit {
  @Input()
  direction = 'top';

  @Input()
  position;

  @Input()
  color;

  @Input()
  colorChange = false;

  @Input()
  msgCustomPosition = false;

  constructor(
    private _storage: StorageService,
  ) { }

  ngOnInit() {
  }

  getPopupBoxArrowStyle() {
    if (this.direction === 'top') {
      return {
        'left': this.msgCustomPosition ? '64.5%' : '50%',
        'top': '0',
        'margin-left': '-7px'
      };
    }

    if (this.direction === 'left') {
      if (this.position) {
        return this.position;
      }

      return {
        'left': '0',
        'top': '50%',
        'margin-top': '-7px'
      };
    }

    if (this.direction === 'bottom') {
      return {
        'left': '50%',
        'top': '0',
        'margin-left': '-11px'
      };
    }
  }

  getPopupBoxArrowOutStyle() {
    const isDark = !!parseInt(this._storage.GetConfig()["isDark"]|| "1");
    if (this.colorChange && !isDark) {
      this.color = '#fafafa';
    } else {
      this.color = '#2b2c3a';
    }
    if (this.direction === 'top') {
      return {
        'top': '-14px',
        // 'border-color': 'transparent transparent rgba(170, 170, 170, 1)',
        'border-color': 'transparent transparent '+this.color,
      };
    }

    if (this.direction === 'left') {
      return {
        'left': '-14px',
        'border-color': 'transparent #000 transparent transparent',
      };
    }

    if (this.direction === 'bottom') {
      return {
        'top': '-6px',
        'border-color': this.color + ' transparent  transparent  transparent',
      };
    }
  }

  getPopupBoxArrowInStyle() {
    const isDark = !!parseInt(this._storage.GetConfig()["isDark"]|| "1");
    if (this.colorChange && !isDark) {
      this.color = '#fafafa';
    } else {
      this.color = '#2b2c3a';
    }
    if (this.direction === 'top') {
      return {
        'left': '-7px',
        'top': '-6px',
        'border-color': 'transparent transparent ' +this.color,
      };
    }

    if (this.direction === 'left') {
      return {
        'top': '-7px',
        'left': '-6px',
        'border-color': 'transparent '+this.color+' transparent transparent',
      };
    }

    if (this.direction === 'bottom') {
      return {
        'left': '-7px',
        'top': '-6px',
        'border-color': this.color + ' transparent  transparent  transparent',
      };
    }
  }

}
